module.exports = __webpack_public_path__ + "static/media/thumb.e377bfe6.jpg";